import { SeoPage, SeoReplaceValues } from 'libs/shared-lib/interfaces';
export const ABOUT_US_SEO_IT: SeoPage = {
    title: `${SeoReplaceValues.DEALER_NAME}: Su di noi`,
    description: '',
    image: '',
    twitter: {
        card: 'summary',
        title: `${SeoReplaceValues.DEALER_NAME}: Su di noi`,
        description: '',
    },
    og: {
        title: `${SeoReplaceValues.DEALER_NAME}: Su di noi`,
        description: '',
    },
    robots: {
        noIndex: false,
        noFollow: false,
    },
};
